import i18n from '@/i18n';
import axios from 'axios';
import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';

export default {
  async indexByGuidelineVersion(guidelineVersionId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.index({
      parentName: 'admin/guideline_version',
      parentId: guidelineVersionId,
      modelName: 'guideline_article_version/index',
      params,
    });
    return res;
  },
  async removeByGuidelineVersion(guidelineVerId, guidelineArticleVerId) {
    const data = {
      factory: store.state.app.factory.id,
      guideline_versions: [guidelineVerId],
    };
    try {
      const res = await axios.post(
        `admin/guideline_article_version/${guidelineArticleVerId}/remove/guideline_version`,
        data,
      );
      return res;
    } catch (err) {
      alert(i18n.t(err));
    }
  },
  async show(versionId, guidelineVerId) {
    const params = {
      factory: store.state.app.factory.id,
      guideline_version: guidelineVerId,
    };
    const res = await base.show({
      modelName: 'admin/guideline_article_version',
      modelId: versionId,
      params,
    });
    return res;
  },
  async update(guidelineArticleVerId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'admin/guideline_article_version',
      modelId: guidelineArticleVerId,
      data: _data,
    });
    return res;
  },
  async create(articleId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'admin/guideline_article',
      parentId: articleId,
      modelName: 'guideline_article_version',
      data: _data,
    });
    return res;
  },
  async indexAnnounce(articleId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.index({
      parentName: 'admin/guideline_article',
      parentId: articleId,
      modelName: 'guideline_article_version/index/announce',
      params,
    });
    return res;
  },
}